import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-woman_lg",
  "use": "icon-woman_lg-usage",
  "viewBox": "0 0 16 30",
  "content": "<symbol viewBox=\"0 0 16 30\" id=\"icon-woman_lg\">\n  <path d=\"M1749,1882.93a8,8,0,1,0-2,0V1887h-6v2h6v8h2v-8h6v-2h-6v-4.07Zm-7-7.93a6,6,0,1,1,6,6A6,6,0,0,1,1742,1875Z\" transform=\"translate(-1740 -1867)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol